import ReactEcharts from "echarts-for-react"; // Import ECharts for React wrapper
import { Text } from "../units/Text";
import { ActivityProps } from "../../interfaces/Accumulator";
import { type AccumulatorChartDataList } from "../../interfaces/AccumulatorChart/types";



const emptyChart = () => {
  return (
    <div className="flex space-between align-center">
      <Text color="secondary">За указанный период нет данных</Text>
      <svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1918_1952)">
          <path d="M0.732468 57.574H6.58442C6.98571 57.574 7.31688 57.2467 7.31688 56.8415V24.648C7.31688 24.2428 6.98961 23.9155 6.58442 23.9155H0.732468C0.331169 23.9155 0 24.2428 0 24.648V56.8415C0 57.2428 0.327273 57.574 0.732468 57.574ZM1.46494 25.3766H5.85195V56.109H1.46494V25.3766Z" fill="#DDDDDD"/>
          <path d="M15.3662 57.5739C15.7675 57.5739 16.0986 57.2466 16.0986 56.8414V18.792C16.0986 18.3868 15.7713 18.0596 15.3662 18.0596H9.51421C9.11291 18.0596 8.78174 18.3868 8.78174 18.792V56.8414C8.78174 57.2427 9.10901 57.5739 9.51421 57.5739H15.3662ZM10.2428 19.5245H14.6337V56.1089H10.2428V19.5245Z" fill="#DDDDDD"/>
          <path d="M24.1481 57.5742C24.5494 57.5742 24.8806 57.247 24.8806 56.8418V12.9405C24.8806 12.5353 24.5533 12.208 24.1481 12.208H18.2962C17.8949 12.208 17.5637 12.5353 17.5637 12.9405V56.8418C17.5637 57.2431 17.891 57.5742 18.2962 57.5742H24.1481ZM19.0248 13.6729H23.4157V56.1132H19.0248V13.669V13.6729Z" fill="#DDDDDD"/>
          <path d="M32.926 57.574C33.3273 57.574 33.6584 57.2467 33.6584 56.8416V1.23247C33.6584 0.827273 33.3312 0.5 32.926 0.5H27.074C26.6727 0.5 26.3416 0.827273 26.3416 1.23247V56.8416C26.3416 57.2429 26.6688 57.574 27.074 57.574H32.926ZM27.8065 1.96493H32.1974V56.1091H27.8065V1.96493Z" fill="#DDDDDD"/>
          <path d="M41.7077 57.5741C42.109 57.5741 42.4402 57.2469 42.4402 56.8417V7.08452C42.4402 6.67932 42.1129 6.35205 41.7077 6.35205H35.8558C35.4545 6.35205 35.1233 6.67932 35.1233 7.08452V56.8417C35.1233 57.243 35.4506 57.5741 35.8558 57.5741H41.7077ZM36.5843 7.81699H40.9752V56.1092H36.5843V7.81699Z" fill="#DDDDDD"/>
          <path d="M50.4897 57.5743C50.891 57.5743 51.2222 57.247 51.2222 56.8418V27.5743C51.2222 27.1691 50.8949 26.8418 50.4897 26.8418H44.6377C44.2364 26.8418 43.9053 27.1691 43.9053 27.5743V56.8418C43.9053 57.2431 44.2325 57.5743 44.6377 57.5743H50.4897ZM45.3663 28.3067H49.7572V56.1132H45.3663V28.3067Z" fill="#DDDDDD"/>
          <path d="M59.2675 18.0596H53.4156C53.0143 18.0596 52.6831 18.3868 52.6831 18.792V56.8414C52.6831 57.2427 53.0104 57.5739 53.4156 57.5739H59.2675C59.6688 57.5739 60 57.2466 60 56.8414V18.792C60 18.3868 59.6727 18.0596 59.2675 18.0596ZM58.5351 56.1089H54.1441V19.5245H58.5351V56.1089Z" fill="#DDDDDD"/>
          <path d="M59.2675 59.0352H0.732468C0.331169 59.0352 0 59.3624 0 59.7676C0 60.1728 0.327273 60.5001 0.732468 60.5001H59.2675C59.6688 60.5001 60 60.1728 60 59.7676C60 59.3624 59.6727 59.0352 59.2675 59.0352Z" fill="#DDDDDD"/>
          </g>
          <defs>
          <clipPath id="clip0_1918_1952">
          <rect width="60" height="60" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
          </defs>
      </svg>
      <div></div>
    </div>
  )
}

const IconLightning = () => {
  return (
    <div className="icon-wrapper" style={{ backgroundColor: "#FF8200" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 11 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "relative", left: "1px" }}
      >
        <path
          d="M6.8242 1.96664L5.32025 6.00108L9.25424 6.01968L2.69503 14.5836L4.7577 8.52446L1.19491 8.50585L3.00883 1.96664H6.8242ZM6.8242 0.850098H3.00883C2.48838 0.850098 2.03681 1.18878 1.89905 1.67634L0.0889484 8.21555C-0.00289585 8.55051 0.0698142 8.9078 0.284118 9.18322C0.498421 9.45863 0.835183 9.62239 1.19108 9.62239L3.17339 9.63356L1.60821 14.2337C1.43217 14.7548 1.66944 15.3205 2.16693 15.5736C2.33531 15.6592 2.51517 15.7001 2.69503 15.7001C3.0471 15.7001 3.39534 15.5401 3.6173 15.2498L10.1727 6.68589C10.4329 6.3472 10.4712 5.89686 10.2798 5.52096C10.0847 5.14506 9.6905 4.90686 9.25807 4.90314L6.95431 4.89198L7.90337 2.34998C8.02965 2.00758 7.9799 1.62795 7.7656 1.32649C7.5513 1.02874 7.19923 0.850098 6.8242 0.850098Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

const IconCharge = () => {
  return (
    <div className="icon-wrapper" style={{ backgroundColor: "#FFC68A" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7254 3.71519H10.0993V1.4075C10.0993 0.794574 9.59701 0.299805 8.97472 0.299805H7.9738C7.35151 0.299805 6.84917 0.794574 6.84917 1.4075V3.71519H5.60084V1.4075C5.60084 0.794574 5.09851 0.299805 4.47621 0.299805H3.4753C2.853 0.299805 2.35067 0.794574 2.35067 1.4075V3.71519H1.72463C1.10234 3.71519 0.600006 4.20996 0.600006 4.82288V9.1798C0.600006 10.9484 1.99829 12.3367 3.78644 12.3367H4.41248V14.6998H8.03753V12.3367H8.66357C10.4517 12.3367 11.85 10.9484 11.85 9.1798V4.82288C11.85 4.20996 11.3477 3.71519 10.7254 3.71519ZM6.9129 13.5921H5.53711V12.3367H6.9129V13.5921ZM10.7254 9.1798C10.7254 10.3429 9.83318 11.229 8.66357 11.229H3.79019C2.62058 11.229 1.72838 10.3392 1.72838 9.1798V4.82288H3.47905V1.4075H4.47996V4.82288H7.97755V1.4075H8.97846V4.82288H10.7291V9.1798H10.7254Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

const IconIdle = () => {
  return (
    <div className="icon-wrapper">
      <svg
        width="20"
        height="20"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.38001 1.33465V11.6657H1.87001V1.33465H5.38001ZM5.38001 0.200195H1.87001C1.22261 0.200195 0.700012 0.706918 0.700012 1.33465V11.6657C0.700012 12.2935 1.22261 12.8002 1.87001 12.8002H5.38001C6.02741 12.8002 6.55001 12.2935 6.55001 11.6657V1.33465C6.55001 0.706918 6.02741 0.200195 5.38001 0.200195Z"
          fill="black"
        />
        <path
          d="M12.13 1.33465V11.6657H8.62001V1.33465H12.13ZM12.13 0.200195H8.62001C7.97261 0.200195 7.45001 0.706918 7.45001 1.33465V11.6657C7.45001 12.2935 7.97261 12.8002 8.62001 12.8002H12.13C12.7774 12.8002 13.3 12.2935 13.3 11.6657V1.33465C13.3 0.706918 12.7774 0.200195 12.13 0.200195Z"
          fill="black"
        />
      </svg>
    </div>
  );
};


const tempVisMap =(index:number, color: string):any => {
  return {
    top: 50,
    right: 10,
    pieces: [
      {
        lte: 10,
        color: 'red'
      },
      {
        gt: 45,
        color: 'red'
      },

    ],
    outOfRange: {
      color: color
    },
    seriesIndex: index
  }
}

export const TemperatureChart = (
  x_labels: string[],
  chartData: AccumulatorChartDataList
) => {
  let series = []
  let vismaps = []
  let i = 0
  for (let item of chartData.cell_temp_max_data.missing) {
      let data = {
          type: "line",
          color: "#FF8200",
          smooth: true,
          symbol: "none",
          data: item,
          tooltip: {
            show: false
          },
          lineStyle: {
            type: 'dashed'
          },
      }
      series.push(data)
      vismaps.push(tempVisMap(i, "#FF8200"))
      i++;
  }

  for (let item of chartData.cell_temp_min_data.missing) {
    let data = {
        type: "line",
        color: "#A8A8A8",
        smooth: true,
        symbol: "none",
        data: item,
        tooltip: {
          show: false
        },
        lineStyle: {
          type: 'dashed'
        },
    }
    series.push(data)
    vismaps.push(tempVisMap(i, "#A8A8A8"))
    i++;
  }

  series.push({
      name: "t max",
        type: "line",
        color: "#FF8200",
        smooth: true,
        symbol: "none",
        data: chartData.cell_temp_max_data.data,
        tooltip: {
          valueFormatter: function (value: any):string {
            if (value) {
              return value + " °C";
            } else {
              return "- °C"
            }
          },
        },
    },)
    vismaps.push(tempVisMap(i, "#FF8200"))
    i++;
    
    series.push({
        name: "t min",
        color: "#A8A8A8",
        type: "line",
        smooth: true,
        data: chartData.cell_temp_min_data.data,
        symbol: "none",
        // itemStyle: {color: 'blue'},
        tooltip: {
          valueFormatter: function (value: any):string {
            if (value) {
              return value + " °C";
            } else {
              return "- °C"
            }
          },
        },
      },
    )
    vismaps.push(tempVisMap(i, "#A8A8A8"))

  const getOption = (series: Array<any>, vismaps: any) => {
    return {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["t min", "t max"],
        selectedMode: false,
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: x_labels, // Generates an array from 0 to 23
      },
      yAxis: {
        type: "value",
        scale: true,
        axisLabel: {
          formatter: "{value} °C", // Assuming values between 0 and 100
        },
      },
      visualMap: vismaps,
      series: series
    };
  };
  return <ReactEcharts option={getOption(series, vismaps)} notMerge={true}/>;
};

export const SocMetric = (numberator: number, denumerator: number) => {
  const getOption = () => {
    return {
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          splitNumber: 4,
          itemStyle: {
            color: "rgba(255, 130, 0, 1)",
            shadowColor: "rgba(255, 130, 0, 0.45)",
            shadowBlur: 10,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
          },
          progress: {
            show: true,
            roundCap: true,
            width: 12,
          },
          pointer: {
            icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
            length: "75%",
            width: 10,
            offsetCenter: [0, "5%"],
          },
          axisLine: {
            roundCap: true,
            lineStyle: {
              width: 3,
            },
          },
          axisTick: {
            splitNumber: 2,
            lineStyle: {
              width: 1,
              color: "#999",
            },
          },
          splitLine: {
            length: 10,
            lineStyle: {
              width: 2,
              color: "#999",
            },
          },
          axisLabel: {
            distance: 5,
            color: "#999",
            fontSize: 10,
          },
          title: {
            show: false,
          },
          detail: null,
          data: [
            {
              value: (numberator / denumerator) * 100,
            },
          ],
        },
      ],
    };
  };

  return <ReactEcharts option={getOption()} notMerge={true}/>;
};

export const BalanceChart = (
  x_labels: string[],
  chartData: AccumulatorChartDataList
) => {
  
  let series: any[] = []
  for (let item of chartData.cell_voltage_mean_data.missing) {
    let data = {
      type: "line",
      color: "#FF8200",
      data: item,
      smooth: false,
      symbol: "none",
      lineStyle: {
        type: 'dashed'
      },
      tooltip: {
        show: false
      },
    }
    series.push(data)
  }
  series.push({
    type: "line",
    name: "U min",
    data: chartData.cell_voltage_min_data.data,
    lineStyle: {
      opacity: 0
    },
    stack: "total",
    symbol: "none",
    color: '#fff',
    smooth: true,
    connectNull: false,
  })

  series.push(
    {
      name: 'U max',
      type: 'line',
      data: chartData.cell_voltage_max_data.data.map((value, index) => {
        if (value) {
          return value - chartData.cell_voltage_min_data.data[index]
        }
      } 

      ),
      smooth: true,
      tooltip : {
        valueFormatter: function (value: number, index: number) {
          if (value) {
            return (value + chartData.cell_voltage_min_data.data[index]).toFixed(3) + ' В';
          } else {
            return "- В"
          }
        }
      },
      lineStyle: {
        opacity: 0
      },
      color: '#fff',
      connectNull: false,
      stack: 'total',
      symbol: 'none',
      areaStyle: {
        color: '#ccc'
      },
    },
  )
  series.push({
    name: "U среднее",
    type: "line",
    color: "#FF8200",
    data: chartData.cell_voltage_mean_data.data,
    smooth: true,
    symbol: "none",
  })
  const getOption = (series: Array<any>) => {
    return {
      tooltip: {
        trigger: "axis",
        order:'seriesDesc',
        valueFormatter: function (value: any) {
          if (value === undefined) { return "- В" }

          return (value).toFixed(3) + ' В';
         
        },
      },
      xAxis: {
        data: x_labels,
        boundaryGap: true,
        type: 'category',

      },
      legend: {
        data: ["U"],
        selectedMode: false,
      },
      yAxis: {
        type: "value",
        scale: true,
        axisLabel: {
          formatter: "{value} В", // Assuming values between 0 and 100
        },
 
      },
      series: series,
    };
  };
  return <ReactEcharts option={getOption(series)} notMerge={true}/>;
};

export const ActivityChart = (activity: ActivityProps | null) => {
  const secondsToDayFormatter = (seconds: number): string => {
    const days = Math.round(seconds / (60 * 60 * 24));
    if (days > 1000) {
      return `>999 д.`;
    }
    return `${days} д.`;
  };

  const share = (nominator: number, denominator: number): number => {
    if (denominator > 0) {
      return parseFloat(((nominator / denominator) * 100).toFixed(2));
    } else {
      return 0;
    }
  };

  if (activity) {
    return (
      <>
        <br />
        <div className="flex battery-activity align-center">
          <div className="flex narrow-gap align-center activity-label">
            {IconLightning()}
            <Text>Разряд</Text>
          </div>
          <div className="flex flex-grow activity-bars-wrapper flex-no-gap">
            <div
              style={{
                width: `${share(activity.dischargeSum, activity.totalTime)}%`,
                backgroundColor: "#FF8200",
              }}
            ></div>
          </div>
          <div className="flex narrow-gap align-center activity-label">
            <Text>{share(activity.dischargeSum, activity.totalTime)}%</Text>
            <Text>/ {secondsToDayFormatter(activity.dischargeSum)}</Text>
          </div>
        </div>
        <br />
        <br />
        <div className="flex battery-activity align-center">
          <div className="flex narrow-gap align-center activity-label">
            {IconCharge()}
            <Text>Заряд</Text>
          </div>
          <div className="flex flex-grow activity-bars-wrapper flex-no-gap">
            <div style={{ width: `${share(activity.dischargeSum, activity.totalTime)}%` }}></div>
            <div
              style={{
                width: `${share(activity.chargeSum, activity.totalTime)}%`,
                backgroundColor: "#FFC68A",
              }}
            ></div>
          </div>
          <div className="flex narrow-gap align-center activity-label">
            <Text>{share(activity.chargeSum, activity.totalTime)}%</Text>
            <Text>/ {secondsToDayFormatter(activity.chargeSum)}</Text>
          </div>
        </div>
        <br />
        <br />
        <div className="flex battery-activity align-center">
          <div className="flex narrow-gap align-center activity-label">
            {IconIdle()}
            <Text>Простой</Text>
          </div>
          <div className="flex flex-grow activity-bars-wrapper flex-no-gap">
            <div style={{ width: `${share(activity.dischargeSum, activity.totalTime)}%` }}></div>
            <div style={{ width: `${share(activity.chargeSum, activity.totalTime)}%` }}></div>
            <div
              style={{
                width: `${share(activity.idleSum, activity.totalTime)}%`,
                backgroundColor: "#A8A8A8",
              }}
            ></div>
          </div>
          <div className="flex narrow-gap align-center activity-label">
            <Text>{share(activity.idleSum, activity.totalTime)}%</Text>
            <Text>/ {secondsToDayFormatter(activity.idleSum)}</Text>
          </div>
        </div>
      </>
    );
  } else {
    return emptyChart()
  }
};